import { Form } from '@unform/web';
import styled from 'styled-components';
import circle from '~/assets/icons/switch-circle.svg';
import circleWhite from '~/assets/icons/switch-circle-white.svg';

export const Container = styled(Form)`
  small {
    font-size: 12px;
  }
  .qty-size {
    width: 191px;
  }
  .border-danger {
    border: 1px solid #dc3545 !important;
  }

  .bd-lots {
    border-radius: 8px;
    border: 1px solid #e1e1e1;
  }

  .all-lots {
    width: 100%;
  }

  .all-lots > h3:nth-child(1),
  .all-lots > div:nth-child(2),
  .all-lots > div:nth-child(3),
  .all-lots > div:nth-child(4) {
    width: 25%;
  }

  .form-switch .form-check-input:focus {
    background-image: url(${circle});
  }
  .form-check-input:checked {
    background-color: #ff6900;
    border-color: #ff6900;
    background-image: url(${circleWhite}) !important;
  }
  .form-check-input {
    width: 3rem;
    height: 1.5rem;
    background-color: transparent;
    border-color: #d3d3d3;
  }
`;
